import { render, staticRenderFns } from "./HorizontalDetailInput.vue?vue&type=template&id=95b40afe&scoped=true&"
import script from "./HorizontalDetailInput.vue?vue&type=script&lang=js&"
export * from "./HorizontalDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalDetailInput.vue?vue&type=style&index=0&id=95b40afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b40afe",
  null
  
)

export default component.exports